export const ErrorCodes = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    BUSINESS_RULE_VIOLATION: 'BUSINESS_RULE_VIOLATION',
    TERMS_ACCEPTANCE_REQUIRED: 'TERMS_ACCEPTANCE_REQUIRED',
    USER_NOT_ENROLLED: 'USER_NOT_ENROLLED',
    ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
    INSTRUCTOR_NOT_SELF_MANAGED: 'INSTRUCTOR_NOT_SELF_MANAGED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    DATABASE_ERROR: 'DATABASE_ERROR',
    EXTERNAL_SERVICE_ERROR: 'EXTERNAL_SERVICE_ERROR',
    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
    MISSING_TENANT: 'MISSING_TENANT',
    RATE_LIMITED: 'RATE_LIMITED',
};
//# sourceMappingURL=response.js.map